import loadable from '@loadable/component'
import {setRegisteredRoutes} from './registered'

export {getRegisteredRoutePaths} from './registered'

const routers = [
  {
    path: '/demo/hiya-ui',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-scroll" */ '../pages/demo/hiya-ui'
        )
    ),
  },
  {
    path: '/demo/scroll',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-scroll" */ '../pages/demo/scroll'
        )
    ),
  },
  {
    path: '/demo/sign',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-sign" */ '../pages/demo/sign'
        )
    ),
  },
  {
    path: '/demo/Aanimation',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-Aanimation" */ '../pages/demo/Aanimation'
        )
    ),
  },
  {
    path: '/demo/Aanimation/Apng',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-demo-Aanimation-Apng" */ '../pages/demo/Aanimation/Apng'
        )
    ),
  },
  {
    path: '/ended',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-ended" */ '../pages/ended')
    ),
  },
  {
    path: '/__routes',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-export-routes" */ '../pages/ExportRoutes'
        )
    ),
  },
  {
    path: '',
    exact: true,
    component: loadable(
      () => import(/* webpackChunkName: "page-notFound" */ '../pages/404')
    ),
  },
]

export const getRouter = (_routers) => {
  const next = [..._routers, ...routers]
  setRegisteredRoutes(next)
  return next
}
